module.exports = __webpack_public_path__ + "static/media/gae.5d45232b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/gae.png
 ** module id = 219
 ** module chunks = 0
 **/